import { useEffect } from "react";
import { datadogRum } from "@datadog/browser-rum";
import { useMsal } from "@azure/msal-react";

export default function DatadogUserIdentify() {
  const { accounts } = useMsal();

  // object destructuring
  const user = accounts[0];
  const userId = user?.localAccountId;
  const username = user?.name || user?.username;
  const email = user?.username;

  useEffect(() => {
    if (userId) {
      datadogRum.setUser({
        id: userId,
        name: username,
        email: email,
      });
    } else {
      datadogRum.clearUser();
    }
  }, [userId, username, email]);

  return null;
}